import { Component, ViewChild } from '@angular/core';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ExpenseCategoryFormComponent } from '../expense-category-form/expense-category-form.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-expense-category',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule,LoaderComponent],
  templateUrl: './expense-category.component.html',
  styleUrl: './expense-category.component.scss'
})
export class ExpenseCategoryComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  HolidayData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private modalService: NgbModal,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ExpenseCategoryMasterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExpenseCategoryMasterSelect() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseCategoryMasterSelect({ ESS_ExpenseCategoryMasterId: 0, SelectType: 1 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addExpenseCategory(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(ExpenseCategoryFormComponent,{ size: 'lg' });
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          this.ESS_ExpenseCategoryMasterSelect();
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
}
